import React from 'react';
import { css } from 'styled-components';
import { applyStyles } from 'util/helpers';
import CustomMedia from 'util/custom-media-query';
import FontStyles from 'constants/font-styles';
import Colors from 'constants/colors';
import MediaBorders from 'constants/media-borders';
import i18n from 'i18n';
import Button from 'components/common/Button';
import BlockHeader from 'components/common/BlockHeader';

class ContactCompletion extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const { className, push } = this.props;
    return (
      <div className={className}>
        <BlockHeader>
          {i18n.t('contact:completion:gratitudeMessage')}
        </BlockHeader>
        <ul className="notification">
          <li>{i18n.t('contact:completion:notificationMessage1')}</li>
          <li>{i18n.t('contact:completion:notificationMessage2')}</li>
          <li>{i18n.t('contact:completion:notificationMessage3')}</li>
        </ul>
        <Button type="button" buttonType="F" onClick={() => push('/')}>
          {i18n.t('contact:completion:backToTop')}
        </Button>
      </div>
    );
  }
}

const commonStyle = css`
  max-width: ${MediaBorders.large};
  height: 100%;
  text-align: center;
  margin: 0 auto;

  ${BlockHeader} {
    &:after {
      left: 50%;
      transform: translate(-50%, 0);
    }
  }

  ul {
    padding-left: 0;
    margin: 0 auto;

    li {
      list-style: none;
    }
  }

  .notification {
    ${FontStyles.text8};

    color: ${Colors.black1};
    text-align: center;
  }

  button {
    display: block;
    margin: 0 auto;
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  .notification {
    margin-bottom: 40px;

    li:first-child {
      margin-bottom: 32px;
    }
  }

  button {
    margin-bottom: 40px;
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  .notification {
    margin-bottom: 32px;

    li:first-child {
      margin: 0 auto 24px;
    }
  }
`;

export default applyStyles(ContactCompletion)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/Contact/Completion/index.js